import { HomeOutlined } from '@ant-design/icons';
import { OPERATIONS } from 'constants';

const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'group',
  exclude: true,
  children: [
    {
      id: 'home',
      title: 'Home',
      navTitle: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: HomeOutlined,
      operations: [OPERATIONS.VIEW]
    }
  ]
};

export default dashboard;
